<template>
    <div class="flex min-h-screen">
        <form v-on:submit.prevent="login" class="flex flex-col space-y-5 m-auto w-full p-5 max-w-xs">
            <span class="text-xl">Connexion Magasin</span>

            <span class="text-red-600" v-if="hasError">Identifiants incorrects</span>

            <aff-input v-model="username" label="Utilisateur" />
            <aff-input v-model="password" label="Mot de passe" type="password" />

            <input v-if="!isLoading" type="submit" value="Se connecter" class="p-2 px-6 cursor-pointer bg-orange-400 hover:bg-orange-500 text-white rounded ml-auto"/>
            <span v-else class="p-2 px-6 ml-auto">Connexion...</span>
        </form>
    </div>
</template>

<script>
const axios = require('axios');
import AffInput from '@/components/inputs/AffInput'

export default {
    components: { AffInput },
    data: function () {
        return {
            username: 'paris_sebastopol',
            password: 'KPY7Ncu',
            isLoading: false,
            hasError: false
        }
    },
    methods: {
        login: function () {
            const payload = {
                username: this.username,
                password: this.password
            };

            this.isLoading = true;
            this.hasError = false;

            axios
            .post(process.env.VUE_APP_API_BASE_URL + 'xiaomi_care/shop/login', payload)
            .then(({data}) => {
                window.sessionStorage.setItem('shop_username', data.shop.username)
                window.sessionStorage.setItem('shop_access_token', data.shop.token)

                this.$router.push('/shop/enrolment');
            })
            .catch(() => {
                this.isLoading = false;
                this.hasError = true;
            })
        }
    }
}
</script>